/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
export const TitleColumnFormatter = (
    cellContent,
    row,
    rowIndex,
) => {
    return <span dangerouslySetInnerHTML={{__html: cellContent}}/>
};
